var PES = PES || {};
PES.Tooltip = function () {

    function init() {
        $('[data-toggle="popover"]')
            .popover({ trigger: "hover", placement: "top", viewport: "#body-content" });

        $('select[data-toggle="popover"], .checkout-item__amount[data-toggle="popover"] > select')
            .change(function () {
                var is_touch_device = ("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch;
                if (is_touch_device) {
                    var _target = this;
                    $(_target).closest('[data-toggle="popover"]').popover('hide');
                }                    
            });

        function ifQtyBoxIsDisabled() {
            var customPopover = $('.checkout-item__amount[data-toggle="popover"]');

            $(customPopover).hover(function () {
                if ($(this).children('select:disabled').length > 0 && $(this).children('input:disabled').not('[data-plan="basic"]').length > 0) {
                    $(this).popover('hide');
                }
            });            
        };

        $('[data-toggle-click="popover"]')
            .popover({
                trigger: "click",
                placement: "top",
                viewport: "#body-content",
                content: function () {
                    var contentSelector = $(this).data('popover-content');
                    return $(contentSelector).html();
                },
                html: true
            }).on('shown.bs.popover', function () {
                var jqPopoverTrigger = $(this);
                var popoverSelector = '#' + jqPopoverTrigger.attr('aria-describedby');
                var jqPopover = $(popoverSelector);
                setTimeout(function () {
                    var isMouseOver = $(popoverSelector + ':hover').length > 0;
                    if (!isMouseOver)
                        jqPopoverTrigger.popover('hide');
                }, 3000);

                jqPopover
                    .on('mouseenter', function () {
                        var _this = this;
                        jqPopover.on('mouseleave', function () {
                            setTimeout(function () {
                                $(_this).popover('hide');
                            }, 500);
                        });
                    });
            });

        $('[data-toggle="slide-popover"]')
            .on({
                mouseenter: function (e) {
                    var slidePopoverId = $(this).data('popover-id');
                    var jqSlidePopover = $('#' + slidePopoverId);
                    var qtySelector = $(' [data-toggle="slide-popover"] > #popup-qty-selector');
                    var y = qtySelector.offset().top - jqSlidePopover.height() - 13;

                    jqSlidePopover.css('opacity', 1);
                    jqSlidePopover.offset({ top: y});
                },
                mouseleave: function () {
                    var slidePopoverId = $(this).data('popover-id');
                    var jqSlidePopover = $('#' + slidePopoverId);
                    jqSlidePopover.css('opacity', 0);
                }
            });        

            if ($(".tooltip-checkout").length > 0) {
                var tooltipTriggerElement = "tooltip-checkout";
                $("." + tooltipTriggerElement)
                    .popover({ trigger: "manual", placement: "top", viewport: "#body-content" });

                function debounce(func, wait) {
                    var timeout;
                    return function () {
                        var context = this, args = arguments;
                        var later = function () {
                            timeout = null;
                            func.apply(context, args);
                        };
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                    };
                };

                function handlePopoverBehaviour(elem) {

                    removeTooltipForDeletedItem();

                    if ($(window).outerWidth() < 1200) {
                        mobileCheck(elem);
                    } else {
                        $('.' + elem).popover('dispose');
                        desktopCheck(elem);
                    }
                };

                function mobileCheck(el) {
                    $("." + el)
                        .popover("hide")
                        .on("focusin", function () {
                            $(this).popover("show");
                        })
                        .on("focusout", function () {
                            $(this).popover("hide");
                        });
                };

                function desktopCheck(el) {
                    $("." + el)
                        .popover("dispose")
                        .off("focusin");
                };

                function removeTooltipForDeletedItem() {
                    $(".checkout-item__delete")
                        .on("click focus", function () {
                        $(".checkout-item__amount.tooltip-checkout").popover("dispose");
                    });

                    $('.checkout-item__amount[data-toggle="checkout-popover"] > select')
                        .change(function () {
                            $(".checkout-item__amount.tooltip-checkout").popover('dispose');
                        });
                }

                $(window).on("resize",
                    debounce(function () {
                        handlePopoverBehaviour(tooltipTriggerElement);
                    }, 500)
                );

                handlePopoverBehaviour(tooltipTriggerElement);
            };
           
        ifQtyBoxIsDisabled();

    }
    return {
        init: init
    };
};